export const environment = {
    production: false,
    API_ORIGIN: 'https://core-staging.smarthink.gr/api',
    AUTH_ORIGIN: 'https://auth-staging.smarthink.gr/',
    AZURE_MEASUREMENTS_URL: 'https://measurement-staging.smarthink.gr/api',
    AZURE_CORE_URL: 'https://core-staging.smarthink.gr/api'
};
